(function() {
	'use strict';

	angular.module('app.leanProjects')
		.service('individualPerformanceService', individualPerformanceService);

	function individualPerformanceService($http, hostUrl, leanFilterService, excelExportService) {
		var urlPfx = '2/factndx/';
		return {
			getData: getData,
			getExcel: getExcel
		};

		function getExcel(modalScope) {
			var pageUrl = buildUrl(true);
			return excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), hostUrl + pageUrl, modalScope);
		}

		function getData() {
			var pageUrl;
			pageUrl = buildUrl();
			return $http.get(hostUrl + pageUrl).then(function(result) {
				return result.data;
			});
		}

		function buildUrl(isExcelExport) {
			var factories = leanFilterService.getFactoryList();
			var url = urlPfx + factories + '/LeanProject/IndividualPerformance';
			if (typeof isExcelExport !== 'undefined' && isExcelExport) {
				url += '?excelRequest=true';
			}
			var qParams = '';
			url = addFilterQueryParams(url);
			return url;
		}

		function addFilterQueryParams(url) {
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1)
				qParams = '?' + parts[1];
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			return parts[0] + qParams;
		}
	}
})();
